import { graphql } from 'gatsby';
import { EventLayout } from '../../components/entities/event-layout';
import { createGatsbyPageComponent } from '@shapeable/ui';

export default createGatsbyPageComponent('Event', { layout: EventLayout });

export const QUERY = graphql`
  query EventQuery($id: ID!) {
    platform {
      event(id: $id) {
        id slug path 
        name
        name_fr
        startDate
        endDate
        overview { text }
        sessionInfo { text }
        description { text }
        description_fr { text }
        color { id value darkValue }
        images { image { id url url2x width height } }
        banner {
          id name slug title description { text } alternateText
          image { 
            id url url2x width height 
          }
        }
        links { id url url_fr name label label_fr isDownload page { path } }
        sessions { 
          id name name_fr __typename 
          startDate endDate
          icsPath(base: "/downloads")
          description { text }
          description_fr { text }
          room { id name shortName name_fr shortName_fr }
          color { id value darkValue }
          presenters { 
            id name 
            bio { html }
            bio_fr { html }
            photo { url url2x }
            openGraph { title description { plain } image { thumbnails { full { url url2x } } } }
          }
          group { id name name_fr shortName shortName_fr }
        }
      }
    }
  }
`;
